export const site = {
    gtmId: 'GTM-5J4S8V',

    url: 'https://loando.pl',

    name: 'LoanDO',
    title: 'LoanDO.pl',
    separator: ' | ',

    lang: {
        head: 'pl',
        meta: 'pl',
    },

    hreflang: [
        { url: 'https://loando.pl/', lang: 'pl' },
        { url: 'https://loando.ro/', lang: 'ro' },
        { url: 'https://loando.cz/', lang: 'cs' },
        { url: 'https://loando.es/', lang: 'es' },
        { url: 'https://loando.mx/', lang: 'es-mx' },
        { url: 'https://loando.ua/', lang: 'uk' },
        { url: 'https://loando.ua/ru/', lang: 'ru-ua' },
    ],

    socialMedia: [{ url: 'https://www.facebook.com/loandopl' }],

    nip: '9492200470',
    krs: '0000548045',
    regon: '361006900',
    contact: {
        phone: '+48611100413',
        email: 'kontakt@loando.pl',

        address: {
            street: 'ul. Marka Kotańskiego 8/3',
            city: 'Olsztyn',
            postalCode: '11-041',
            addressCountry: 'PL',
        },
    },
};
